<script lang="ts" setup>
import HomeSecondaryActions from '@components/Home/HomeSecondaryActions.vue'
import BtnSeeOrder from '@components/ui/footer/actions/BtnSeeOrder.vue'
import FooterCart from '@components/ui/footer/FooterCart.vue'
import FooterSkeleton from '@components/ui/footer/FooterSkeleton.vue'
import FooterUserCard from '@components/ui/footer/FooterUserCard.vue'
import Header from '@components/ui/Header.vue'
import AsideCategories from '@components/ui/navigation/AsideCategories.vue'
import AsideMenu from '@components/ui/navigation/AsideMenu.vue'
import Spinner from '@components/ui/Spinner.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const isHome = computed(() => route.name === 'home')
</script>

<template>
  <main class="flex h-full max-h-svh flex-col">
    <Header />
    <div class="p-vw-32 gap-vw-32 flex flex-1 flex-row overflow-hidden">
      <aside class="flex w-[calc(248*var(--vw))] min-w-[calc(248*var(--vw))] flex-col">
        <AsideMenu />
        <AsideCategories />
      </aside>
      <Suspense>
        <div class="h-full w-full">
          <slot></slot>
        </div>
        <template #fallback>
          <div class="flex w-full flex-col items-center justify-center">
            <Spinner class="h-16 w-16" />
          </div>
        </template>
      </Suspense>
    </div>
    <FooterSkeleton>
      <template #identification>
        <div class="p-vh-32 h-full min-h-[calc(216*var(--vh))] w-[calc(312*var(--vw))] pb-0">
          <FooterUserCard />
        </div>
      </template>

      <template #primary-actions>
        <div class="gap-vw-16 flex flex-row items-center justify-end">
          <FooterCart class="w-1/2" />
          <BtnSeeOrder />
        </div>
      </template>

      <template v-if="isHome" #secondary-actions>
        <HomeSecondaryActions />
      </template>
    </FooterSkeleton>
  </main>
</template>
